'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = AddItemsToTopCheckbox;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _baseCheckbox = require('@bibliocommons/base-checkbox');

var _baseCheckbox2 = _interopRequireDefault(_baseCheckbox);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function AddItemsToTopCheckbox(_ref) {
  var value = _ref.value,
      handleChange = _ref.handleChange;

  return _react2.default.createElement(
    'div',
    { className: 'cp-add-items-to-top-checkbox' },
    _react2.default.createElement(_baseCheckbox2.default, {
      id: 'add-items-to-top-checkbox',
      checked: value,
      handleChange: handleChange,
      labelTestId: 'add-items-to-top-checkbox-label',
      label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'user_list_add_items_to_top_label' }) })
  );
}

AddItemsToTopCheckbox.propTypes = {
  value: _react.PropTypes.bool.isRequired,
  handleChange: _react.PropTypes.func.isRequired
};


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/user-list/lib/components/add-items-to-top-checkbox/components/AddItemsToTopCheckbox.component.js
// module id = 1271
// module chunks = 0